import React from 'react';
import { AirtableDataConsumer, AirtableContextData } from '../../core/AirtableDataProvider';

import './PageNav.scss';
import { Link } from 'gatsby';
import { nestPages } from './pageUtil';

interface Props {

}

export default class PageNav extends React.Component<Props> {

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const pages = nestPages(data.airtable.pages);

    return (
      <div className="page-nav flex flex-row">
        { pages.map(page => {
          let toHref = `/${ page.meta.Path || page.meta.Slug }`
          if (toHref === '//') {
            toHref = '/'
          }

          return (
            <div key={ page.meta.Slug } className="f5 pl4 pt1 relative">
              <Link
                className="link main-link dark-gray dim pt2 pb4"
                activeClassName="active"
                to={toHref} >
                { page.meta.Caption }
              </Link>
              { page.children.length ?

                <div className="dn link-menu absolute mt3 theme--top-bar" style={{ whiteSpace: 'nowrap' }}>
                { page.children.map(child =>
                  <div key={ child.meta.Slug } className="pa3 bt b--gray">
                    <Link
                      className="link dim b0" to={ `/${ child.meta.Path || child.meta.Slug }` } activeClassName="b">
                      { child.meta.Caption }
                    </Link>
                  </div>
                ) }
              </div>

              : null }
            </div>
          )
        })}
      </div>
    );
  }

}